export const time = {
    "alert_time_out": "ໝົດ ເວລາແລ້ວ!",
    "hours": "ຊົ່ວໂມງ",
    "minute": "ນາທີ",
    "second": "ວິນາທີ",
    "time_worked": "ໄລຍະເວລາ",
    "time": "ໄລຍະເວລາ",
    "times": "ການທົດສອບ",
};

